// Canonical ApiError shape; produced only by error-normalize.ts.

export interface ApiError {
  message: string;
  status: number;
  fieldErrors?: Record<string, string[]>;
  originalError: unknown;
}

export function isApiError(value: unknown): value is ApiError {
  return (
    value !== null &&
    typeof value === 'object' &&
    'message' in value &&
    typeof (value as Record<string, unknown>)['message'] === 'string' &&
    'status' in value &&
    typeof (value as Record<string, unknown>)['status'] === 'number' &&
    'originalError' in value
  );
}
